import { useAuth } from '../contexts/AuthContext';

export default function LoginPage({ onShowPricing }) {
  const { signInWithGoogle, supabaseUnreachable } = useAuth();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1e3a8a 0%, #4338ca 100%)',
      fontFamily: "'Segoe UI', -apple-system, sans-serif",
      direction: 'rtl',
    }}>
      <div style={{
        background: 'white',
        borderRadius: 20,
        padding: '48px 40px',
        maxWidth: 420,
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <div style={{ marginBottom: 28, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {/* Sophisticated Geometric Icon */}
          <div style={{
            width: 76,
            height: 76,
            borderRadius: '24px',
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
            boxShadow: '0 20px 40px -10px rgba(15, 23, 42, 0.5), inset 0 2px 4px rgba(255,255,255,0.1)'
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="url(#goldGrad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="miter">
              <defs>
                <linearGradient id="goldGrad" x1="0" y1="1" x2="1" y2="0">
                  <stop offset="0%" stopColor="#b45309" />
                  <stop offset="50%" stopColor="#fbbf24" />
                  <stop offset="100%" stopColor="#fef3c7" />
                </linearGradient>
              </defs>
              {/* Abstract 'M' / Chart peaks */}
              <path d="M3 20 L8 4 L12 14 L16 4 L21 20" />
              <line x1="2" y1="20" x2="22" y2="20" strokeWidth="2.5"/>
            </svg>
          </div>
          
          {/* Logo Text - Unified & Elegant */}
          <div style={{
            fontSize: 56,
            fontWeight: 900,
            letterSpacing: '0.06em',
            fontFamily: "'Playfair Display', 'Cinzel', 'Georgia', serif",
            color: '#0f172a',
            margin: '0 0 10px',
            lineHeight: 1.1,
            direction: 'ltr'
          }}>
            MIVIDA
          </div>
          
          {/* Slogan */}
          <p style={{ fontSize: 18, fontWeight: 500, color: '#475569', margin: '0 0 6px', lineHeight: 1.6 }}>
            מערכת תכנון הפרישה <strong style={{ color: '#b45309', fontWeight: 800 }}>הטובה בישראל</strong>
          </p>
          <p style={{ fontSize: 13.5, color: '#94a3b8', margin: '0', lineHeight: 1.6, fontWeight: 500, maxWidth: '100%' }}>
            טופסי 161 · קיבוע זכויות · חתימה דיגיטלית<br/>
            תכנון פרישה מותאם אישית · אסטרטגיות גמישות · התאמה מלאה ללקוח
          </p>
        </div>

        <button
          onClick={signInWithGoogle}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            width: '100%',
            padding: '13px 24px',
            borderRadius: 10,
            border: '1.5px solid #e2e8f0',
            background: 'white',
            cursor: 'pointer',
            fontSize: 15,
            fontWeight: 600,
            color: '#1e293b',
            transition: 'all 0.15s',
            direction: 'ltr',
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
          onMouseLeave={e => e.currentTarget.style.background = 'white'}
        >
          <GoogleIcon />
          Sign in with Google
        </button>

        {supabaseUnreachable && (
          <div style={{
            marginTop: 16,
            padding: '10px 14px',
            borderRadius: 10,
            background: '#fef3c7',
            border: '1px solid #fcd34d',
            color: '#92400e',
            fontSize: 13,
            lineHeight: 1.6,
          }}>
            ⚠️ לא ניתן להתחבר כרגע לשרת. ייתכן שהמערכת מתעוררת — נסה שוב בעוד כ-30 שניות, או רענן את הדף.
          </div>
        )}

        <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 16, lineHeight: 1.5 }}>
          ✨ משתמשים חדשים מקבלים <strong>ניסיון חינמי של 30 יום</strong> — ללא כרטיס אשראי
        </p>

        {onShowPricing && (
          <button
            onClick={onShowPricing}
            style={{
              marginTop: 20,
              background: 'transparent',
              border: 'none',
              color: '#4338ca',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 600,
              padding: '6px 0',
              textDecoration: 'underline',
              textDecorationColor: '#c7d2fe',
              textUnderlineOffset: 3,
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#1e293b'}
            onMouseLeave={e => e.currentTarget.style.color = '#4338ca'}
          >
            ראה מחירים ותכונות ←
          </button>
        )}
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  );
}
